import "./NavModal.scss";
import { Link } from "react-router-dom";
function NavModal({ setHamburger }) {
  const closeMenu = () => {
    setHamburger(true);
  };

  return (
    <div className="nav-modal-overlay" onClick={closeMenu}>
      <div
        className="nav-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Mobile navigation menu"
      >
        <button
          type="button"
          onClick={closeMenu}
          className="nav-modal__exit"
          aria-label="Close navigation menu"
        >
          X
        </button>

        <nav id="mobile-navigation" aria-label="Mobile primary navigation">
          <a
            className="nav-modal__menu"
            href="/#home"
            onClick={closeMenu}
            data-click-location="mobile_nav"
            data-section="home"
          >
            Home
          </a>

          <a
            className="nav-modal__menu"
            href="/#projects"
            onClick={closeMenu}
            data-click-location="mobile_nav"
            data-section="projects"
          >
            Projects
          </a>

          <a
            className="nav-modal__menu"
            href="/#skills"
            onClick={closeMenu}
            data-click-location="mobile_nav"
            data-section="skills"
          >
            Skills
          </a>

          <a
            className="nav-modal__menu"
            href="/#about"
            onClick={closeMenu}
            data-click-location="mobile_nav"
            data-section="about"
          >
            About Me
          </a>

          <a
            className="nav-modal__menu"
            href="/#contact"
            onClick={closeMenu}
            data-click-location="mobile_nav"
            data-section="contact"
          >
            Contact
          </a>
        </nav>

        <div className="nav-modal__legal">
          <Link
            className="nav-modal__legal-link"
            to="/privacy"
            onClick={closeMenu}
            data-click-location="mobile_nav"
            data-section="privacy"
          >
            Privacy Policy
          </Link>

          <Link
            className="nav-modal__legal-link"
            to="/cookies"
            onClick={closeMenu}
            data-click-location="mobile_nav"
            data-section="cookies"
          >
            Cookie Policy
          </Link>
        </div>
      </div>
    </div>
  );
}

export default NavModal;
